import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
} from '@material-ui/core';
import { useState } from 'react';
import Title from './Title';
import {
  clearReducer,
  getMedicacionEmpadronamientosActivosHistorialPrevio,
  setActiveStep,
  setAfiliadoSeleccionado,
} from '../../../../../actions/empadronamiento/Empadronamiento';
import { EmpadronamientoHistorialItem } from '../../../../empadronamiento/Ingreso/EmpadronamientoHistorialItem';
import { STEPPER_EMPADRONAMIENTO } from '../../../../../utils/constants';
import { EMPADRONAMIENTO_MENU_PERMISOS } from '../../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { PlantillaEmpadronamiento } from '../../../Empadronamientos/PlantillaEmpadronamiento';
import { ModalEmpadronamientoHce } from '../../../Empadronamientos/ModalEmpadronamientoHce';

export const CardEmpadronamiento = (props) => {
  const dispatch = useDispatch();
  const { hce, dataAfiliado, disabled } = props;
  const [openModalEmpadronamiento, setOpenModalEmpadronamiento] = useState(false);
  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { solicitudesActivas } = useSelector((state) => state.empadronamiento);


  useEffect(() => {
    if (hce?.idAfiliado) {
      dispatch(
        getMedicacionEmpadronamientosActivosHistorialPrevio(hce.idAfiliado),
      );
      dispatch(clearReducer());
    }
  }, [dispatch]);

  return (
    <React.Fragment>
        {openModalEmpadronamiento &&
        <ModalEmpadronamientoHce
          open={openModalEmpadronamiento}
          close={() => {
            setOpenModalEmpadronamiento(false);
          }}

        />

      }
      <Title>
        Empadronamientos Activos{' '}
        {validarSoloUnPermiso(
          permisosUser,
          EMPADRONAMIENTO_MENU_PERMISOS.INGRESO_SOLICITUD,
        ) &&
          (
            <>
              {!disabled &&
                <Button
                  disabled={disabled || hce.idAfiliado ? false : true}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    dispatch(setAfiliadoSeleccionado(dataAfiliado));
                    dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DATOS_TITULAR));
                    setOpenModalEmpadronamiento(true);
                  }}
                >
                  + Ingresar empadronamiento
                </Button>
              }
            </>

          )}
        <PlantillaEmpadronamiento descarga={true} />
      </Title>
      {Array.isArray(solicitudesActivas) && solicitudesActivas?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '15%' }}>Estado</TableCell>
              <TableCell style={{ width: '6%' }}>Solicitud</TableCell>
              <TableCell style={{ width: '10%' }}>Inicio</TableCell>
              <TableCell style={{ width: '10%' }}>Fin</TableCell>
              <TableCell style={{ width: '20%' }}>Programa</TableCell>
              <TableCell style={{ width: '12%' }}>Usuario</TableCell>
              <TableCell style={{ width: '5%' }}>Medicamentos</TableCell>
              <TableCell style={{ width: '5%' }}>Diagnósticos</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {solicitudesActivas.map((solicitud, index) => {
              return (
                <EmpadronamientoHistorialItem
                  key={solicitud?.idSolicitud.toString()}
                  solicitud={solicitud}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
          No hay Empadronamientos activos
        </Typography>
      )}
    </React.Fragment>
  );
};
